import{makeAccessor}from"../core/index.js";export const buttonsGroupDirection=makeAccessor(["row","column"]);
//# sourceMappingURL=buttons-group.props.js.map